/** The maximum allowed file size for uploads, in bytes (100 MB). */
export const MAX_FILE_SIZE_BYTES = 100 * 1_000_000;

/**
 * The maximum number of files that can be uploaded at once. This is NestJS
 * validation limit.
 */
export const MAX_FILE_NUMBER = 10;

export const BUCKET_NAMES = {
  automationEmails: 'automation-emails',
  bills: 'bills',
  billsStaging: 'bills_staging',
  clientData: 'client_data',
  users: 'users',
};

export const MIME_TYPES = {
  csv: 'text/csv',
  jpeg: 'image/jpeg',
  parquet: 'application/vnd.apache.parquet',
  pdf: 'application/pdf',
  png: 'image/png',
  tnef: 'application/ms-tnef',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  zip: 'application/x-zip-compressed',
};

export const FILE_TYPES = {
  billUpload: ['jpg', 'jpeg', 'pdf', 'png'],
  profilePicture: ['jpg', 'jpeg', 'png'],
  table: [
    'csv',
    // 'parquet', // Parquet file upload disabled for now
    'xls',
    'xlsx',
  ],
};

export const UPLOADER_MIME_SETTINGS: Record<
  keyof typeof FILE_TYPES,
  Record<string, string[]>
> = {
  billUpload: {
    [MIME_TYPES.jpeg]: ['.jpg'], // treating .jpg and .jpeg the same
    [MIME_TYPES.pdf]: ['.pdf'],
    [MIME_TYPES.png]: ['.png'],
  },
  profilePicture: {}, // Uploader component not currently used for profile picture
  table: {
    [MIME_TYPES.csv]: ['.csv'],
    [MIME_TYPES.xls]: ['.xls'],
    [MIME_TYPES.xlsx]: ['.xlsx'],
    [MIME_TYPES.parquet]: ['.parquet'],
  },
};

/**
 * Regex to match accepted table mime types:
 * - `text/csv`: The standard MIME type for CSV files.
 * - `application/vnd.ms-excel`: A common MIME type for older .xls files
 * (and sometimes used for CSVs opened in Excel).
 * - `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`: The
 * standard MIME type for modern .xlsx files.
 * - `application/parquet`: A common MIME type for Parquet files.
 */
export const TABLE_MIME_TYPES_REGEX =
  /^(text\/csv|application\/vnd\.ms-excel|application\/vnd\.openxmlformats-officedocument\.spreadsheetml\.sheet|application\/parquet)$/i;
